export const SHIPPING_V2_PENDING_LABEL =
  "Ongkir dihitung saat Periksa Pesanan";

export interface ShippingV2DisplayDetail {
  zone: "INSIDE_DENPASAR" | "OUTSIDE_DENPASAR";
  rawRoadKm: number | null;
}

export function shippingV2AreaDistanceLabel(
  detail: ShippingV2DisplayDetail,
): string {
  const area = detail.zone === "INSIDE_DENPASAR"
    ? "Dalam Denpasar"
    : "Luar Denpasar";
  if (detail.rawRoadKm === null) {
    return `${area} • tarif area`;
  }
  const distance = new Intl.NumberFormat("id-ID", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
  }).format(detail.rawRoadKm);
  return `${area} • ${distance} km`;
}

interface ValidatedCheckoutShipping {
  shippingPath: "LEGACY" | "V2";
  deliveryFee: number;
  total: number;
}

export function deriveCheckoutShippingSummary(input: {
  shippingV2Enabled: boolean;
  deliveryType: "DELIVERY" | "PICKUP";
  legacyDeliveryFee: number;
  legacyTotal: number;
  hasShippingV2Quote: boolean;
  preview?: ValidatedCheckoutShipping;
}) {
  const validatedV2 =
    input.shippingV2Enabled &&
    input.deliveryType === "DELIVERY" &&
    input.hasShippingV2Quote &&
    input.preview?.shippingPath === "V2"
      ? input.preview
      : undefined;
  const pending =
    input.shippingV2Enabled &&
    input.deliveryType === "DELIVERY" &&
    input.preview?.shippingPath !== "LEGACY" &&
    !validatedV2;

  return {
    pending,
    deliveryFee: validatedV2?.deliveryFee ?? input.legacyDeliveryFee,
    total: validatedV2?.total ?? input.legacyTotal,
  };
}
